import VerificationCodeInput from '@helpers/helpComponents/VerificationCode';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Animated } from 'react-animated-css';
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap'
import { NotificationManager } from 'react-notifications';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import LecturaEvaluacion from './LecturaEvaluacion';
import EventoAcceso from './AccesoEvento';
import UserContext from '@context/User/UserContext';
import dashboardRoutesPaths from '@helpers/dashboardRoutesPaths/dashboardRoutesPaths';
import { getInfoEstudianteLectura, getResultadoFinal } from '@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura';

const particlesOptions = {
    fpsLimit: 60,
    particles: {
        number: {
            value: 100,
            density: {
                enable: true,
            },
        },
        color: {
            value: ["#ffcc00", "#ffffff", "#ff9900"],
        },
        opacity: {
            value: { min: 0.1, max: 0.6 },
        },
        size: {
            value: { min: 1, max: 3 },
        },
        move: {
            enable: true,
            speed: 4,
            random: false,
        },
    },
    interactivity: {
        detectsOn: "window",
        events: {
            onClick: {
                enable: true,
                mode: "push",
            },
            resize: true,
        },
    },
    background: {
        image: "url('https://globalclickmexico.com/img/loginNuevo.webp')",
        position: "50% 50%",
        size: "cover",
        repeat: "no-repeat",
    },
};

const validarCodigoAcceso = (codigo) =>{
    console.log('Codigo validado, ', codigo);
    NotificationManager.success("Codigo validado")
}

const CompetenciasLecturaVeloz = ({history}) => {

    const {contextValue, setContexValue} = useContext(UserContext);

    const {usuarioLogeado = {}} = contextValue;

    const [showEvaluacion, setShowEvaluacion] = useState(false);

    const [codigoCompetencia, setCodigoCompetencia] = useState('CLV9');

    const [codigoFinal, setCodigoFinal] = useState('default'); //👈🏾 se usa para validar si es prueba de semifinal o final de curso

    const [lecturaEvento, setLecturaEvento] = useState({});

    //todo Desarrollar las 3 fases para la prueba:
    //*Primer evento de clasificatoria con un temporizador normal
    //*Segundo evento de clasificatoria con un contra reloj
    //*Evento de cierre del curso.
    
    // const particlesInit = useCallback(async (engine) => {
    //         await loadFull(engine);
    //     }, []);

    //Se reciben los datos para manejarlos en la vista pública
    const param = new URLSearchParams(window.location.search);

    const getResultadoFinalCurso = async (code) => {
        const enSemifinal = code === 'semi' ? 1 : 0;
        try{
            const {data} = await getResultadoFinal({idPerfil: usuarioLogeado.idPerfil, enSemifinal});

            const {data: info} = data;
            console.log(info);
            setLecturaEvento(info);

        }catch(e) {
            console.log('Error al recuperar los resultados del usuario')
        }
    }

    const [infoPlantel, setInfoPlantel] = useState({});

    useEffect(() => {

        const obtenerInfoPlantel = async() => {
            try{
                const {data: info} = await getInfoEstudianteLectura(usuarioLogeado.idPerfil);
                const {data} = info;
                console.log(data)
                setInfoPlantel(data);
            }catch(error) {
                console.log('Error al recuperar la información del plantel');
            }
        }
        obtenerInfoPlantel();
        
        const datosURL = param.get("competencia");
        const codigoFinal = param.get("code");

        console.log(datosURL);

        if(datosURL){
            setCodigoCompetencia(datosURL);
        }

        //se valida si se recibe el parametro code para validar si es semifinal o final
         if(codigoFinal){
            if(codigoFinal === 'semi') { 
                setCodigoCompetencia('CL10');
                getResultadoFinalCurso(codigoFinal);
                setCodigoFinal('semi')
            }
            if(codigoFinal === 'final'){
                setCodigoCompetencia('CL11');
                getResultadoFinalCurso(codigoFinal);
                setCodigoFinal('final')
            }
        }

        if(Object.keys(usuarioLogeado).length === 0){
                history.replace(dashboardRoutesPaths.default);
        }
    }, [])
    
    return (

        <>

            {showEvaluacion ? (
                <LecturaEvaluacion infoPlantel={infoPlantel} lecturaEvento={lecturaEvento} codigoFinal={codigoFinal} codigoCompetencia={codigoCompetencia} usuarioLogeado={usuarioLogeado} />
            ): (
                <EventoAcceso codigoCompetencia={codigoCompetencia} usuarioLogeado={usuarioLogeado} setShowEvaluacion={setShowEvaluacion} />
            )}


        </>
        
    )
}

export default CompetenciasLecturaVeloz